import { useEffect } from 'react'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { RequestsTable } from 'modules/salary_advance/pages/RequestPage/RequestsTable/RequestsTable'

const RequestsPage = () => {
  useEffect(() => {
    track(trackingEvents.salaryAdvance.viewRequests)
  }, [])

  return (
    <ResponsivePage.Body variant="full">
      <RequestsTable />
    </ResponsivePage.Body>
  )
}

export default RequestsPage
